import { GetTokenSilentlyVerboseResponse } from "@auth0/auth0-spa-js";
import jwt, { JwtPayload } from "jsonwebtoken";
// @ts-ignore
import Vue from "vue";

export class MockAuth0Client {
    token: string;
    private decodedJwtPayload: Record<string, any>;

    constructor(token: string) {
        this.token = token;
        this.decodedJwtPayload = {};

        this.decodedJwtPayload = jwt.decode(this.token) as JwtPayload;
    }

    async isAuthenticated(): Promise<boolean> {
        return Boolean(this.token);
    }

    async handleRedirectCallback(): Promise<void> {
        return;
    }

    async loginWithRedirect(): Promise<void> {
        return;
    }

    async getUser(): Promise<Record<string, string>> {
        return this.decodedJwtPayload;
    }

    async logout({ returnTo }: { returnTo: string }): Promise<void> {
        Vue.prototype.$cookies.remove("overwriteToken");

        window.location.assign(returnTo);
    }

    async getTokenSilently(): Promise<GetTokenSilentlyVerboseResponse> {
        return {
            access_token: this.token,
            id_token: this.token,
            expires_in: this.decodedJwtPayload.exp - this.decodedJwtPayload.iat,
            scope: "openid profile email",
        };
    }
}
